import { BigNumber, type BigNumberProps } from './components/big-number'
import { Body, type BodyProps } from './components/body'
import { Caption, type CaptionProps } from './components/caption'
import { Subtitle, type SubtitleProps } from './components/subtitle'
import { Title, type TitleProps } from './components/title'

const Typography = {
  BigNumber,
  Title,
  Subtitle,
  Body,
  Caption,
}

export { Typography }
export type {
  BigNumberProps,
  TitleProps,
  SubtitleProps,
  BodyProps,
  CaptionProps,
}
